export default "__VITE_ASSET__a791b845__"